import React from "react";

const PlatformHeroSection = ({ data }) => (

    <section className="sx-platform-hero">

        <div className="container">

            <div className="sx-platform-hero-content">

                <div className="sx-eyebrow">
                    {data.eyebrow}
                </div>

                <h1>
                    {data.title}
                    {data.highlight && (
                        <>
                            {" "}
                            <span>{data.highlight}</span>
                        </>
                    )}
                </h1>

                {data.lead && (
                    <p className="sx-platform-lead">
                        {data.lead}
                    </p>
                )}

            </div>

        </div>

    </section>
);

export default PlatformHeroSection;